<template>
	<fieldset class="_form-email-field" :name="name">
		<Layout :error="displayErrors && !valid">
			<template #index>{{ formatInteger(Number(index), 2) }}.</template>
			<template #label>
				<legend>{{ label }}</legend>
			</template>
			<template #input>
				<input type="email" class="-p-large" :placeholder="placeholder" autocomplete="email" @input="onInput" />
			</template>
		</Layout>
	</fieldset>
</template>

<script>
import Layout from './Layout'
import { formatInteger, isValidEmail } from '@/helpers/strings'

export default {
	components: { Layout },
	inject: ['$form'],
	props: {
		index: { type: [Number, String], default: 1 },
		type: { type: String, default: 'email' },
		name: { type: String, required: true },
		label: { type: String, required: true },
		placeholder: { type: String, default: undefined },
		displayErrors: { type: Boolean, default: false },
	},
	data() {
		return {
			value: undefined,
			valid: false,
		}
	},
	methods: {
		formatInteger,
		onInput({ target }) {
			this.value = target.value.length > 0 ? target.value : undefined
			this.valid = isValidEmail(this.value)

			this.$form.setField(this.name, {
				value: this.value,
				valid: this.valid,
			})
		},
	},
}
</script>
